import React, { useState, useRef, useEffect } from "react";
import { FileText, Settings, Award, X, DatabaseBackup, Package } from "lucide-react";

// styles
import styles from "./styles.module.css";
// components
import AddInvoice from "../AddInvoice";
import MyNotes from "../MyNotes";
import Profile from "../../pages/User/Profile";
import ChangePlan from "../ChangePlan";
import DataBackup from "../DataBackup";
import ManageProducts from "../ManageProducts";

function QuickActions({ expandedCard: externalExpanded, setExpandedCard: externalSetExpanded }){
    const [internalExpanded, setInternalExpanded] = useState(null);
 
    // Usa o estado externo se foi passado via props, senão usa o interno
    const expandedCard    = externalExpanded   !== undefined ? externalExpanded   : internalExpanded;
    const setExpandedCard = externalSetExpanded || setInternalExpanded;
    const expandedRef = useRef(null);

    const actions = [
        {
            title: "Nova Nota",
            description: "Criar orçamento",
            color: "indigo",
            icon: <FileText className={styles.iconIndigo} />,
            component: <AddInvoice />,
        },
        {
            title: "Minhas Notas",
            description: "Ver todas as notas",
            color: "green",
            icon: <FileText className={styles.iconGreen} />,
            component: <MyNotes />,
        },
        {
            title: "Estoque",
            description: "Gerenciar produtos",
            color: "seaBlue",
            icon: <Package className={styles.iconSeaBlue} />,
            component: <ManageProducts />,
        },
        {
            title: "Upgrade",
            description: "Alterar Plano",
            color: "purple",
            icon: <Award className={styles.iconPurple} />,
            component: <ChangePlan />,
        },
        {
            title: "Backup",
            description: "Backup de Dados",
            color: "orange",
            icon: <DatabaseBackup className={styles.iconOrange} />,
            component: <DataBackup />,
        },
        {
            title: "Configurações",
            description: "Editar Perfil",
            color: "blue",
            icon: <Settings className={styles.iconBlue} />,
            component: <Profile />,
        },
    ];

    // Quando um card expande, rola suavemente até ele ficar centralizado na viweport
    useEffect(() => {
        if (expandedCard && expandedRef.current) {
            expandedRef.current.scrollIntoView({ behavior: "smooth", block: "center"});
        }
    }, [expandedCard]);

    const handleClick = (title) => {
        setExpandedCard(prev => prev === title ? null : title);
    }

    return (
        <div className={styles.grid}>
            {actions.map((action, index) => {
                const isActive = expandedCard === action.title;

                const cardClasseNames = `${styles.card} 
                ${styles[`border${action.color}`]} ${styles.isExpanded}
                ${isActive ? styles.isExpanded : ""}`;

                const cardStyle = isActive ? { gridColumn: "1 / -1", width: "100%", order: "-1", position: "relative"} : {};

                if(isActive) {
                    return (
                        <div key={index} ref={expandedRef} className={cardClasseNames} style={cardStyle}>
                             {/* ── Cabeçalho do card expandido ── */}
                            <div className={styles.expandedHeader}>
                                <div className={styles.expandedMeta}>
                                    <div className={`${styles.iconWrapper} ${styles[`bg${action.color}`]}`}>
                                        {action.icon}
                                    </div>
                                    <span className={styles.expandedTitle}>{action.title}</span>
                                </div>
 
                                <button
                                    onClick={() => setExpandedCard(null)}
                                    className={styles.btnClose}
                                    title="Fechar"
                                >
                                    <X size={16} strokeWidth={2.5} />
                                    <span>Fechar</span>
                                </button>
                            </div>
 
                            {/* ── Conteúdo ── */}
                            <div className={styles.expandedBody}>
                                {action.component}
                            </div>
                        </div>
                    )
                }
                return (
                    <div key={index} className={`${styles.card} ${styles[`border${action.color}`]}`}
                        style={{ width: "100%"}}
                        onClick={() => handleClick(action.title)}
                    >
                        <div className={styles.cardContent}>
                            <div>
                                <h3 className={styles.title}>{action.title}</h3>
                                <p className={styles.description}>{action.description}</p>
                            </div>
                            <div className={`${styles.iconWrapper} ${styles[`bg${action.color}`]}`}>
                                {action.icon}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default QuickActions;